import { render } from "./DetaliiUtilizator.vue?vue&type=template&id=8faf6e98&scoped=true"
import script from "./DetaliiUtilizator.vue?vue&type=script&lang=js"
export * from "./DetaliiUtilizator.vue?vue&type=script&lang=js"

import "./DetaliiUtilizator.vue?vue&type=style&index=0&id=8faf6e98&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8faf6e98"]])

export default __exports__